import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  divider: {
    borderColor: theme.palette.grey[300],
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  summaryNumber: {
    fontWeight: theme.typography.fontWeightBold,
  },
  completionMessage: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.secondary,
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  cancelButton: {
    textTransform: 'none',
    color: theme.palette.primary.main,
  },
  saveButton: {
    textTransform: 'none',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
});
